export default __webpack_public_path__ + "static/media/map.5d9fc823.png";